import { render, staticRenderFns } from "./chat-bot.vue?vue&type=template&id=c190f4ee&scoped=true&"
import script from "./chat-bot.vue?vue&type=script&lang=js&"
export * from "./chat-bot.vue?vue&type=script&lang=js&"
import style0 from "./chat-bot.vue?vue&type=style&index=0&id=c190f4ee&scoped=true&lang=scss&"
import style1 from "./chat-bot.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c190f4ee",
  null
  
)

export default component.exports